import React, { Component } from 'react'
import { Link } from 'app/common/link'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import type { ImageShortDTO } from 'shared/types'
import { Picture } from 'app/common/picture'

type Props = {
    actionUrl: string,
    image: ImageShortDTO,
    external: boolean
}
type State = {
    width: number
}

class Banner extends Component<Props, State> {
    state = { width: window.innerWidth }

    componentDidMount() {
        this.getWidth()
        window.addEventListener('resize', this.getWidth)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getWidth)
    }

    getWidth = () => {
        this.setState({
            width: window.innerWidth
        })
    }

    render() {
        const { actionUrl, image, external } = this.props

        return (
            <Link external={external} url={actionUrl}>
                <Square>
                    <Picture
                        imageTitle={actionUrl}
                        imageUrlLandscape={image.imageUrlLandscape}
                        imageUrlPortrait={image.imageUrlPortrait}
                        desktopRatio="3/1"
                        mobileRatio="2/1"
                    />
                </Square>
            </Link>
        )
    }
}

const Square = styled.div`
    width: calc(100% - 16px);
    margin-left: 8px;
    border-radius: 12px;
    box-sizing: border-box;
    box-shadow: 5px 10px 20px -10px ${colors.shadow};
    overflow: hidden;
    font-size: 0;
    ${media.medium`
        width: calc(100% - 25px);
        margin-left: 0;
    `};
    ${media.large`
        width: calc(100% - 40px);
        margin-left: 0;
    `};
`

export { Banner }
